module.exports = "<svg viewBox=\"0 0 17 20\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"#FFF\" fill-rule=\"evenodd\"><path d=\"M7 2.2c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5m0 12c-3.859 0-7-3.14-7-7 0-3.859 3.141-7 7-7s7 3.141 7 7c0 3.86-3.141 7-7 7M16.146 16.824l-2.96-3.808a8.497 8.497 0 0 1-2.87 2.012l3.06 3.933a1.795 1.795 0 1 0 2.77-2.137\"/></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./icons/search.svg
// module id = 91
// module chunks = 0